import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Form, Typography, Table, Button, Input, Icon, Tag, Modal } from 'antd'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import { green } from '@material-ui/core/colors'
import 'antd/dist/antd.css'
import Highlighter from 'react-highlight-words'
import { Markup } from 'interweave';
import Format from '../../../utils/format'
import { withTranslation } from 'react-i18next'
import adminI18n from '../../../admin/i18n/adminI18n'

const { Title } = Typography;

@inject(
    'webSettingStore',
    'specialOfferStore'
)
@observer
class SpecialOfferList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
        this.props.webSettingStore.getData();
    }

    createClicked = () => this.props.specialOfferStore.initCreate()
    updateClicked = specialOfferId => this.props.specialOfferStore.initUpdate(specialOfferId)
    removeClicked = specialOfferId => this.props.specialOfferStore.deleteSpecialOffer(specialOfferId)

    deleteClicked = specialOfferId => {
        const { t } = this.props;
        Modal.confirm({
            title: t('Remove In Room Dining (Special Offer)'),
            content: t('Are you sure to remove this offer?'),
            okText: t('Remove'),
            cancelText: t('Cancel'),
            onOk: () => this.removeClicked(specialOfferId)
        });
    }

    getColumns = () => {
        const { t } = this.props;
        const { data: webSettting } = this.props.webSettingStore;

        return [
            {
                title: t('Title'),
                dataIndex: 'title',
                key: 'title',
                ...this.getColumnSearchProps('title')
            },
            {
                title: t('Item Name'),
                dataIndex: 'taskName',
                key: 'taskName',
                ...this.getColumnSearchProps('taskName')
            },
            {
                title: t('Brief Desc'),
                dataIndex: 'briefDesc',
                key: 'briefDesc',
                ...this.getColumnSearchProps('briefDesc'),
                render: briefDesc => (
                    <Markup content={briefDesc} />
                )
            },
            {
                title: t('Original Price'),
                dataIndex: 'originalPrice',
                key: 'originalPrice',
                render: originalPrice => (
                    <Tag color={'blue'} style={{ fontSize: 14, padding: '5px 15px 5px 15px' }}>
                        {webSettting ? webSettting.currencyCode : ''} {Format.Currency(originalPrice)}
                    </Tag>
                )
            },
            {
                title: t('Special Price'),
                dataIndex: 'price',
                key: 'price',
                render: price => (
                    <Tag color={'green'} style={{ fontSize: 14, padding: '5px 15px 5px 15px' }}>
                        {webSettting ? webSettting.currencyCode : ''} {Format.Currency(price)}
                    </Tag>
                )
            },
            {
                title: t('Start Date'),
                dataIndex: 'startDate',
                key: 'startDate',
            },
            {
                title: t('End Date'),
                dataIndex: 'endDate',
                key: 'endDate',
            },
            {
                title: t('Sort'),
                dataIndex: 'sort',
                key: 'sort',
            },
            {
                title: t('Action'),
                dataIndex: 'specialOfferId',
                key: 'action',
                render: specialOfferId => (
                    <span>
                        <Button onClick={() => this.updateClicked(specialOfferId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <EditIcon style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button>
                        <Button onClick={() => this.deleteClicked(specialOfferId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: '#DC004E', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
            const { t } = this.props;
            return (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            this.searchInput = node
                        }}
                        placeholder={`${t('Search')} ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type='primary'
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon='search'
                        size='small'
                        style={{ width: 90, marginRight: 8 }}
                    >
                        {t('Search')}
                </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                        {t('Reset')}
                </Button>
                </div>
            )
        },
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                    text
                ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    render() {
        const { t } = this.props;
        const {
            specialOffers
        } = this.props.specialOfferStore;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3} style={{ width: '80%', position: 'relative', float: 'left' }}>{t('In Room Dining Offer List')}</Title>
                        <div style={{ textAlign: 'right' }}>
                            <button type='button' style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={this.createClicked}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div>
                    </div>
                    <Table columns={this.getColumns()} dataSource={specialOffers} />
                </Form>
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(SpecialOfferList);